import React, { useEffect, useRef, useState } from "react";
import { HexAlphaColorPicker } from "react-colorful";
import { Label } from "../ui/label";

type ColorPickerProps = {
  value?: string;
  onChange?: (color: string) => void;
};

const ColorPicker = ({
  value,
  onChange,
}: ColorPickerProps): React.ReactElement => {
  const [colorPicker, setColorPicker] = useState<boolean>(false);
  const [internalColor, setInternalColor] = useState("#222");
  const colorPickerRef = useRef<HTMLDivElement | null>(null);

  const color = value ?? internalColor;

  const handleChange = (newColor: string): void => {
    if (onChange) {
      onChange(newColor);
    } else {
      setInternalColor(newColor);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setInternalColor(value);
    }
  }, [value]);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent): void => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(e.target as Node)
      ) {
        setColorPicker(false);
      }
    };
    if (colorPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return (): void =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [colorPicker]);

  const visibleColors = [
    {
      id: 1,
      color: "#FFFFFF",
    },
    {
      id: 2,
      color: "#000000",
    },
    {
      id: 3,
      color: "#FF5733",
    },
    {
      id: 4,
      color: "#FF8D1A",
    },
    {
      id: 5,
      color: "#28B463",
    },
    {
      id: 6,
      color: "#3498DB",
    },
    {
      id: 7,
      color: "#5DADE2",
    },
    {
      id: 8,
      color: "#2E86C1",
    },
    {
      id: 9,
      color: "#8E44AD",
    },
    {
      id: 10,
      color: "#27AE60",
    },
    {
      id: 11,
      color: "#2B64F4",
    },
    {
      id: 12,
      color: "#138D75",
    },
  ];

  return (
    <div ref={colorPickerRef} className="pt-1.5">
      <Label className="mb-2">Select Color</Label>
      <div className="space-x-2.5">
        <button
          type="button"
          className="size-5 rounded-full"
          style={{ backgroundColor: color }}
          onClick={() => setColorPicker((prev) => !prev)}
        />
        {/* Selected Color */}
        <button
          className="size-5 rounded-[4px] border border-foreground"
          style={{ backgroundColor: color }}
        />
        {visibleColors.map((clr, index) => (
          <button
            key={clr.id || index}
            className="size-5 rounded-full border border-border hover:scale-110 transition-transform duration-200"
            style={{ backgroundColor: clr.color }}
            onClick={() => handleChange(clr.color)}
          />
        ))}
      </div>
      {colorPicker && (
        <div className="absolute bottom-37 sm:bottom-24 left-6 z-50">
          <div className="color-picker-wrapper">
            <HexAlphaColorPicker
              onClick={(e) => e.stopPropagation()}
              color={color}
              onChange={handleChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
